// src/App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import AnalyticsListener from "./analytics/AnalyticsListener";

// Composants
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";

// Pages
import Galerie from "./pages/Galerie";
import Services from "./pages/Services";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AccesClients from "./pages/AccesClients";

// Styles globaux
import "./index.css";

export default function App() {
  return (
    <Router>
      {/* Écoute les changements de route pour GA4 */}
      <AnalyticsListener />

      <div className="app-shell">
        <Navbar />

        <main>
          <Routes>
            {/* Accueil → redirige vers /galerie */}
            <Route path="/" element={<Navigate to="/galerie" replace />} />

            {/* Pages principales */}
            <Route path="/galerie" element={<Galerie />} />
            <Route path="/services" element={<Services />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />

            {/* Accès clients */}
            <Route path="/acces-clients" element={<AccesClients />} />

            {/* 404 */}
            <Route path="*" element={<Navigate to="/galerie" replace />} />
          </Routes>
        </main>

        <Footer />
      </div>
    </Router>
  );
}